import { FC } from "react";

const DbDataProtectionRules: FC = () => {
  return (
    null
  )
}

export default DbDataProtectionRules;
